import React, { useRef } from "react";

interface IProps {
    selectedTab: string;
    changeIndex: any;
}

const Dictionary: React.FunctionComponent<IProps> = (props) => {
    const checkFraudRef = useRef<HTMLDivElement>(null);
    const fraudRingRef = useRef<HTMLDivElement>(null);
    const criminalOrganizationRef = useRef<HTMLDivElement>(null);

    const moveToSelectedRef = (myRef: any, tabIndex: any, tabName: string) => {
        if (tabName !== props.selectedTab) {
            props.changeIndex(tabIndex, tabName);
        }
        if (myRef !== null && myRef.current !== null) {
            myRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    };

    if (props.selectedTab === "A") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-1">
                        Accidental Internet Exposure
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-1">
                        <p>The exposure of information as a result of unintended access to the Internet.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-2">
                        Account Takeover
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-2">
                        <p>
                            A form of payments fraud whereby the fraudster obtains full control over an account and locks the legitimate owner out. Usually done by
                            changing the PIN or password, or changing the statement mailing address.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-3">
                        Account Hijacking
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-3">
                        <p>When a hacker steals an account to perform malicious acts.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-4">
                        Adware
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-4">
                        <p>Software that automatically displays or downloads material when a user is offline.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-5">
                        Antivirus Protection
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-5">
                        <p>Software that is intended to protect your computer against malware and other electronic viruses.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "B") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-6">
                        Backup
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-6">
                        <p>A copy of data, in case it is lost or deleted.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-7">
                        Black Hat Hacker
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-7">
                        <p>Someone who tries to break into a network by exploiting security vulnerabilities.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-8">
                        Blacklist
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-8">
                        <p>A list of emails or service providers that send spam messages.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-9">
                        Breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-9">
                        <p>
                            Unauthorized access to a computer system's sensitive, protected and/or confidential information, and the viewing, theft, or illegal use
                            of the information.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-10">
                        Brute Force Attack
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-10">
                        <p>When a hacker uses a machine to repeatedly try multiple passwords it succeeds.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-11">
                        Bot (Internet bot, web bot)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-11">
                        <p>Software that is programmed to perform automated tasks on the Internet.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-12">
                        Business breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-12">
                        <p>A breach that occurs within a business or organization.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-13">
                        Business email compromise (BEC)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-13">
                        <p>
                            A scam that utilizes legitimate email accounts to scam money or personal information from a business. These scams target businesses that
                            use wire transfers, foreign suppliers, and other invoice transactions.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "C") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-14">
                        Catfishing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-14">
                        <p>
                            When a user pretends to be someone else by stealing their photos and creating a fake account. Catfishing is commonly associated with
                            romantic scams.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term" id="check-fraud" ref={checkFraudRef}>
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-15">
                        Check Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-15">
                        <p>A criminal act in which a perpetrator deliberately uses checks to partake in deceptive banking practices for personal gain.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-16">
                        Check Kiting
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-16">
                        <p>
                            Taking advantage of the float time (the time it takes for the bank to process a check) to make use of non-existent funds in a checking
                            account. See also{" "}
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => moveToSelectedRef(checkFraudRef, 2, "C")}
                            >
                                <span className="btn-text dictionary-see-also-span">Check Fraud</span>
                            </button>
                            .
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-17">
                        Check Washing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-17">
                        <p>
                            Using chemicals and solvents to remove or modify handwriting on a check to assist in forgery. See also{" "}
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => moveToSelectedRef(checkFraudRef, 2, "C")}
                            >
                                <span className="btn-text dictionary-see-also-span"> Check Fraud</span>
                            </button>
                            .
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-18">
                        Child Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-18">
                        <p>
                            When the victim of identity theft is a minor. Because a child, or parent acting on behalf of the child, is unlikely to request credit
                            reports or try to obtain credit, the theft can go undetected for an extended period time.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-19">
                        Credit Card Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-19">
                        <p>Stealing credit card/financial information illegally.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-20">
                        Credit Freeze (Security Freeze)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-20">
                        <p>
                            A method for preventing a credit file from being shared with potential creditors or insurance companies so new lines of credit cannot be
                            opened in your name. This is done individually by contacting each of the three credit monitoring bureaus.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-21">
                        Criminal Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-21">
                        <p>When somebody commits (non-identity related) crimes under an assumed identity.</p>
                    </div>
                </div>
                <div className="dictionary-term" ref={criminalOrganizationRef}>
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-22">
                        Criminal Organization
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-22">
                        <p>
                            A group of individuals who work together to commit fraud. See also{" "}
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => moveToSelectedRef(fraudRingRef, 5, "F")}
                            >
                                <span className="btn-text dictionary-see-also-span"> Fraud Ring</span>
                            </button>
                            .
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-23">
                        Cyberbullying
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-23">
                        <p>
                            The act of using online platforms to carry out bullying behavior (i.e. posting mean or embarrassing photos, threatening comments, etc.).
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-24">
                        Cybercrime
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-24">
                        <p>Fraud perpetrated on the Internet or through the use of computers.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-25">
                        Cybersecurity
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-25">
                        <p>Measures taken to protect a computer/computer system (on the Internet) against unauthorized access or attack.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "D") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-26">
                        Data Breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-26">
                        <p>
                            The unauthorized access to a computer system's sensitive, protected and/or confidential information, and the viewing, theft, or illegal
                            use of the information.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-27">
                        Data Broker
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-27">
                        <p>
                            An individual or business that aggregates information from multiple sources as a service (i.e. public databases, people finders,
                            background check websites, etc.).
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-28">
                        Data on the Move
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-28">
                        <p>
                            The exposure of information due to the transport or movement of information and information containers (computers, folders, hard drives,
                            etc.) from where they are normally kept.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-29">
                        DDoS
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-29">
                        <p>A denial of service attack makes a website unstable by flooding it with traffic.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-30">
                        Doxing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-30">
                        <p>
                            A type of trolling that consists of posting some or all of the personal information (name, address, phone number, Social Security
                            number, birth date, etc.) of victims online for public view.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-31">
                        Dumpster Diving
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-31">
                        <p>
                            Occurs when someone goes through your trash looking for bills, preapproved credit card applications or other mail that contains your
                            personal information. Always shred sensitive material before you dispose of it.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "E") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-32">
                        Educational Breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-32">
                        <p>A breach that occurs within an educational institution.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-33">
                        Embezzlement
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-33">
                        <p>The theft of another's property or assets by a person who is in a position of trust, such as an employee.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-34">
                        Employee Error
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-34">
                        <p>The unintended exposure of information as a result of an error made by an employee.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-35">
                        Employment Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-35">
                        <p>Stealing personal information or acquiring monetary compensation by posing as a legitimate business looking for hire.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-36">
                        Encryption
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-36">
                        <p>Securing data by encoding it so no third parties can watch or access the information.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "F") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-37">
                        Financial Breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-37">
                        <p>A breach that occurs within a financial corporation.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-38">
                        Financial Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-38">
                        <p>When a person uses an assumed identity for personal monetary gain.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-39">
                        Firewall
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-39">
                        <p>A network security system that filters incoming and outgoing traffic.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-40">
                        First-party Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-40">
                        <p>When a legitimate customer opens an account, withdrawals money, and has no intention of repayment.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-41">
                        Float Time
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-41">
                        <p>
                            The time between when an individual writes and submits a check as a payment and when the individual's bank receives the instruction to
                            move funds from the account.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-42">
                        Forgery
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-42">
                        <p>The process of counterfeiting or altering documents, such as a check, with the intent to deceive.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-43">
                        Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-43">
                        <p>
                            The theft and misuse of a victim's personal information and existing financial accounts. This includes stealing personally identifiable
                            information (PII) and ATM/debit card information to make fraudulent transactions.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-44">
                        Fraudster
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-44">
                        <p>A person who commits fraud.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-45">
                        Fraud Prevention
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-45">
                        <p>Taking the steps that best protect against fraud, identity theft and other external threats targeting companies and individuals.</p>
                    </div>
                </div>
                <div className="dictionary-term" ref={fraudRingRef} id="fraud-ring">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-46">
                        Fraud Ring
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-46">
                        <p>
                            A group of individuals who work together to commit fraud. See also{" "}
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => moveToSelectedRef(criminalOrganizationRef, 2, "C")}
                            >
                                <span className="btn-text dictionary-see-also-span"> Criminal Organization</span>
                            </button>
                            .
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "G") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-47">
                        Government/Military Breach
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-47">
                        <p>A breach that occurs within a government or military-based facility.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "H") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-48">
                        Hacker (Security Hacker)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-48">
                        <p>A person who uses technical skills to break into computer systems or networks.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-49">
                        Hacking
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-49">
                        <p>The exposure of information as a result of a targeted attack executed through unauthorized access to a computer or network.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "I") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-50">
                        Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-50">
                        <p>
                            The theft of an individual's PII and subsequent impersonation of their identity to create new accounts using all, or portions of, their
                            information. This includes using a stolen Social Security number to open a credit card in someone else's name.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-51">
                        Insider Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-51">
                        <p>
                            The exposure of information as a result of theft orchestrated by an individual within the institution such as an employee or staff
                            member (either former or current).
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "J") {
        return null;
    } else if (props.selectedTab === "K") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-52">
                        Keystroke Logging
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-52">
                        <p>
                            Software that discreetly tracks the computer keys typed on a keyboard. This software is typically used to obtain usernames, passwords,
                            and PINs.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "L") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-53">
                        Lurking
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-53">
                        <p>
                            When someone secretly searches or reviews an individual's social media content (photos, text, posts, shares, basic profile information,
                            etc.), typically for the purpose of gathering information. Motivations behind lurking can range from personal boredom to criminal
                            activity.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "M") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-54">
                        Malvertising
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-54">
                        <p>The use of online advertising to spread malware.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-55">
                        Malware
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-55">
                        <p>Software that contains specialized code designed to damage or allow unauthorized access to a computer.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-56">
                        Man-in-the-Browser
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-56">
                        <p>
                            A type of Trojan horse (computer virus) that infects a web browser. It takes advantage of vulnerabilities in your browser to discretely
                            modify web pages, transaction content or insert additional transactions.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-57">
                        Medicaid Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-57">
                        <p>When any provider of health care has defrauded the state Medicaid system.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-58">
                        Medical Breach (Health Care Breach)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-58">
                        <p>A breach that occurs within a medical institution or health care company.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-59">
                        Medical Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-59">
                        <p>When a person seeks medical treatment or prescription drugs under an assumed identity.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-60">
                        Medicare Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-60">
                        <p>The collection of Medicare health care reimbursements under false pretenses. It can be both internal and external fraud.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-61">
                        Microprinting
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-61">
                        <p>
                            A security feature on checks. Text is printed too small to be photocopied legibly. It prevents fraudsters from making fraudulent copies
                            of checks.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "N") {
        return null;
    } else if (props.selectedTab === "O") {
        return null;
    } else if (props.selectedTab === "P") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-62">
                        Paper Hanging
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-62">
                        <p>
                            A perpetrator will knowingly deposit a bad check into their account, but (unlike check kiting) they will disregard the float period and
                            abandon the account. See also See also{" "}
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => moveToSelectedRef(checkFraudRef, 2, "C")}
                            >
                                <span className="btn-text dictionary-see-also-span"> Check Fraud</span>
                            </button>
                            .
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-63">
                        Payments Fraud
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-63">
                        <p>An encompassing term used to describe fraud related to credit, debit, or other payment cards.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-64">
                        Personal Health Information (PHI)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-64">
                        <p>The information pertaining to personal medical records (diagnoses, test/lab results, insurance provider information, etc.)</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-65">
                        Personally Identifiable Information (PII)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-65">
                        <p>
                            Any information that can be used on its own or with other pieces of personal information that can distinguish a person as an individual
                            (name, address, Social Security number, date of birth, etc.).
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-66">
                        Phishing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-66">
                        <p>Posing as a legitimate person or company online with the intention of stealing money or personal information.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-67">
                        Physical Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-67">
                        <p>
                            The exposure of information due to physical theft of information and/or information containers (computers, folders, hard drives, etc.)
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-68">
                        Privacy policy
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-68">
                        <p>
                            A statement that discloses a company's practices related to their collection and use of personal information. Typically the policy
                            includes what consumer information may be shared with others and for what purposes, what choices are available to the consumer regarding
                            the collection and use of their data, what security procedures are used, and how a consumer can correct any inaccuracies.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "Q") {
        return null;
    } else if (props.selectedTab === "R") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-69">
                        Ransomware
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-69">
                        <p>
                            Malware that encrypts data and denies access without a decryption key, which is withheld by the fraudster until a ransom is paid within
                            a certain time period.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-70">
                        Rootkit
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-70">
                        <p>Malware deployed to enter a system and steal company information.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "S") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-71">
                        Scam
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-71">
                        <p>A game or fraudulent scheme with the intention of stealing money or personal information.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-72">
                        Security Freeze (Credit Freeze)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-72">
                        <p>
                            A method for preventing a credit file from being shared with potential creditors or insurance companies so new lines of credit cannot be
                            opened in your name. This is done individually by contacting each of the three credit monitoring bureaus.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-73">
                        Security Hacker (Hacker)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-73">
                        <p>A person who uses technical skills to break into computer systems or networks.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-74">
                        Skimming
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-74">
                        <p>
                            Occurs when someone steals your payment card information through a special device that attaches to payment terminals. Look for signs
                            that a payment terminal has been tampered with and use a chip-embedded payment card when possible.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-75">
                        SMSishing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-75">
                        <p>
                            Occurs when you receive an SMS text message that appears to be from a reputable source, such as your bank, asking for personal details.
                            The message will often send you to a malicious website with the goal of stealing your personal or financial data.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-76">
                        Social Engineering
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-76">
                        <p>The manipulation techniques that are used to convince somebody of a scam's legitimacy.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-77">
                        Spear Phishing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-77">
                        <p>A type of phishing attack that targets a group of people (i.e. employees, members, or customers of an organization). </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-78">
                        Spyware
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-78">
                        <p>Malicious software that gathers information about a computer or network discretely.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-79">
                        Storage Encryption
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-79">
                        <p>A storage security feature that uses encryption and decryption of archived data while it is in transit and being stored.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-80">
                        Swatting
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-80">
                        <p>
                            A type of trolling where Internet trolls make fake calls to emergency personnel, impersonating their victims. The term “swatting” comes
                            from the idea that these fake calls usually lead to unnecessary police or SWAT raids at the victims' residences.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-81">
                        Synthetic Identity Theft
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-81">
                        <p>When a person uses a valid Social Security number to create a fake identity.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "T") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-82">
                        Third-Party Error (Subcontractor Error)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-82">
                        <p>
                            The unintended exposure of information as a result of a third party or subcontractor error
                            <br />
                            <strong>Transaction fees</strong>
                            <br />
                            These are fees charged for certain uses of your credit line, credit card or ATM card.
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-83">
                        Trojan (Horse)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-83">
                        <p>A type of virus that appears legitimate but performs illicit activity when activated.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-84">
                        Trolling (Business Pages)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-84">
                        <p>
                            The act of deliberately instigating emotional reactions from others through inflammatory or offensive online interactions on
                            business-related pages or groups that can be motivated by controversies surrounding a business' actions or connections (affiliations,
                            political or religious statements, mergers, business deals, partnerships, ownership changes, etc.).
                        </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-85">
                        Trolling (Personal Pages)
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-85">
                        <p>
                            The act of deliberately instigating emotional reactions from others through inflammatory or offensive online interactions on personal
                            pages or non-business related groups.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "U") {
        return null;
    } else if (props.selectedTab === "V") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-86">
                        Virus
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-86">
                        <p>A type of cyber-attack that activates a program within a computer system to cause damage to computer files.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-87">
                        Vishing
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-87">
                        <p>Posing as a legitimate person or company over the phone with the intention of stealing money or personal information.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "W") {
        return (
            <React.Fragment>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-88">
                        Web Beacon
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-88">
                        <p>Typically a single-pixel graphic or image that is placed on websites to track user activity.</p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-89">
                        Whaling
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-89">
                        <p>A type of phishing attack that targets high-level executives (CEOs, owners, board members, etc.). </p>
                    </div>
                </div>
                <div className="dictionary-term">
                    <h3 className="dictionary-title" aria-describedby="account-monitoring-90">
                        Worm
                    </h3>
                    <div className="dictionary-text" id="account-monitoring-90">
                        <p>A type of cyber-attack that travels through a computer's memory and hard drive to cause a computer to crash.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    } else if (props.selectedTab === "X") {
        return null;
    } else if (props.selectedTab === "Y") {
        return null;
    } else if (props.selectedTab === "Z") {
        return null;
    } else if (props.selectedTab === "0-9") {
        return null;
    } else {
        return null;
    }
};

export default Dictionary;
